import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ClipboardList, Users, Clock, DollarSign } from "lucide-react";
import { Link } from "react-router-dom";
import { AnalyzerControl } from "@/components/AnalyzerControl";

export default function Dashboard() {
  return (
    <div className="space-y-8" data-testid="dashboard-page">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold font-['Manrope'] tracking-tight">
          Dashboard
        </h1>
        <p className="text-muted-foreground mt-1">
          Bienvenido al sistema de gestión de laboratorio
        </p>
      </div>

      {/* Quick Actions - Horizontal */}
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-lg font-['Manrope']">
            Acciones Rápidas
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Link
              to="/reception/new-patient"
              className="flex flex-col items-center gap-3 p-6 rounded-lg bg-slate-50 hover:bg-secondary transition-colors group"
              data-testid="quick-new-patient"
            >
              <div className="p-4 rounded-xl bg-[#0284C7] group-hover:scale-105 transition-transform">
                <Users className="h-8 w-8 text-white" />
              </div>
              <span className="text-sm font-medium text-center">Nuevo Paciente</span>
            </Link>
            <Link
              to="/reception/results"
              className="flex flex-col items-center gap-3 p-6 rounded-lg bg-slate-50 hover:bg-secondary transition-colors group"
              data-testid="quick-results"
            >
              <div className="p-4 rounded-xl bg-amber-500 group-hover:scale-105 transition-transform">
                <Clock className="h-8 w-8 text-white" />
              </div>
              <span className="text-sm font-medium text-center">Capturar Resultados</span>
            </Link>
            <Link
              to="/reception/work-order"
              className="flex flex-col items-center gap-3 p-6 rounded-lg bg-slate-50 hover:bg-secondary transition-colors group"
              data-testid="quick-work-order"
            >
              <div className="p-4 rounded-xl bg-emerald-500 group-hover:scale-105 transition-transform">
                <ClipboardList className="h-8 w-8 text-white" />
              </div>
              <span className="text-sm font-medium text-center">Nueva Orden de Trabajo</span>
            </Link>
            <Link
              to="/reception/quotation"
              className="flex flex-col items-center gap-3 p-6 rounded-lg bg-slate-50 hover:bg-secondary transition-colors group"
              data-testid="quick-quotation"
            >
              <div className="p-4 rounded-xl bg-violet-500 group-hover:scale-105 transition-transform">
                <DollarSign className="h-8 w-8 text-white" />
              </div>
              <span className="text-sm font-medium text-center">Cotización</span>
            </Link>
          </div>
        </CardContent>
      </Card>

      {/* Control de Equipos / Analizadores */}
      <AnalyzerControl />
    </div>
  );
}
